/**
 * Converts a time to minutes for easier comparison
 *
 * @param amPmTime string i.e. '10:00AM', '12:30PM'
 * @returns number of minutes
 */
export function amPmTimeToMinutes(amPmTime: string): number {
  const time = amPmTime.slice(0, -2);
  const meridian = amPmTime.slice(-2);

  let [hoursStr, minutesStr] = time.split(':');

  let hours = parseInt(hoursStr);
  let minutes = parseInt(minutesStr);

  if (!hours || hours === 12) hours = 0;
  if (!minutes) minutes = 0;
  if (meridian.toUpperCase() === 'PM') hours += 12;

  return hours * 60 + minutes;
}

/**
 * Compares string like '8:00AM' with '9:00PM'
 *
 * @param aTime string i.e. '10:00AM', '12:30PM'
 * @param abime string i.e. '10:00AM', '12:30PM'
 * @returns number -1,0,1 for sort comparison
 */
export function compareTime(aTime: string, bTime: string) {
  const aMinutes = amPmTimeToMinutes(aTime);
  const bMinutes = amPmTimeToMinutes(bTime);

  if (aMinutes < bMinutes) return -1;
  if (bMinutes < aMinutes) return 1;

  return 0;
}

/**
 * Returns current date in format expected as SQL param
 * 
 * @returns string date i.e. "2023-01-27"
 */
export function getCurrentDate() {
  const dt = new Date().toLocaleDateString().split('/');
  return `${dt[2]}-${dt[0].padStart(2, '0')}-${dt[1].padStart(2, '0')}`;
}
